'use strict';
import React from 'react';
import flux from 'utils/flux';
import store from 'store';
import {Link} from 'react-router';
import _cloneDeep from 'lodash/lang/cloneDeep';
import isEmpty from 'lodash/lang/isEmpty';
import {assign, range} from 'lodash';
import classnames from 'classnames';
import fallbackConfig from '../../fallbackConfig';

var MediaHeaderPagination = React.createClass({
    displayName: 'MediaHeaderPagination',
    propTypes: {
        pagination: React.PropTypes.object
    },
    contextTypes: {
        router: React.PropTypes.func.isRequired
    },
    shouldComponentUpdate() {
        return !flux.getStore('media').isLoading();
    },
    updatePerPage(event) {
        const per_page = typeof(event) === 'object' ? event.target.value : event;
        let query = _cloneDeep(this.context.router.getCurrentQuery());
        query.page = 1;
        query.per_page = per_page;
        store.set('pagination_amount', query.per_page);
        this.context.router.transitionTo('listing', null, query);
    },
    render() {
        const { amountResults, defaultPerPageResults, progressivePagination } = flux.getStore('app').getState().config.toJS();
        let defaultAmountResults = fallbackConfig.amountResults;

        if (Array.isArray(amountResults) && amountResults.length > 0) {
            defaultAmountResults = amountResults;
        }

        var query = _cloneDeep(this.context.router.getCurrentQuery());
        const { router } = this.context;
        const route = router.getRouteAtDepth(1);
        const isLanding = route && 'landing-page' === route.name;

        if (!this.props.pagination || isLanding || this.props.pagination.get('total_records') === 0) {
            return false;
        }

        var pagination = this.props.pagination.toJS();
        pagination.per_page = store.get('pagination_amount') ? store.get('pagination_amount') : pagination.per_page;
        var maxPages = Math.ceil(pagination.total_records / pagination.per_page);

        query.page = parseInt(query.page, 10) || 1;
        var queryNext = _cloneDeep(query);
        var queryPrev = _cloneDeep(query);

        queryNext.page = (queryNext.page < maxPages ? queryNext.page + 1 : queryNext.page);
        queryPrev.page = (queryPrev.page >= 2 ? queryPrev.page - 1 : queryPrev.page);
        if (queryPrev.page === 1) {
            delete queryPrev.page;
        }
        if (queryNext.page === 1) {
            delete queryNext.page;
        }

        let perPageValue =  query.per_page || store.get('pagination_amount') || defaultPerPageResults;

        return (
            <div className="headerbar__pagination">
                <Link role="button" query={queryPrev} className={classnames({ 'pagination__disabled': 1 === pagination.page })} to="listing">&lt;</Link>
                <span className="pagination__info">
                    {!progressivePagination && flux.getStore('translations').getFormattedMessage('pagination', {
                        from: pagination.page,
                        until: maxPages
                    })}
                    {progressivePagination && (() => {
                        const numPages = 5;
                        const { page } = pagination;
                        var pRange = [];
                        var pQuery = _cloneDeep( query );
                        delete pQuery.page;
                        if ( page < numPages - 1 ) {
                            pRange = range( 1, Math.min( numPages, maxPages ) + 1 );
                        }
                        else if ( page <= maxPages ) {
                            pRange = range( page - 2, Math.min( page + 3, maxPages + 1 ) );
                            while ( pRange.length < 5 ) {
                                pRange.unshift( pRange[0] - 1 );
                            }
                        }
                        return pRange.map( ( p, i ) => {
                          return <Link to="listing"
                          query={assign( {}, pQuery, p > 1 ? { page: p } : null )}
                          key={i} className={classnames('pagination__page', { 'current': p === query.page })}>{p}{ i < 4 ? '\u00A0' : '' }</Link>
                        })
                    })()}
                </span>
                <Link role="button" className={classnames('pagination_next', { 'pagination__disabled': maxPages === pagination.page })} to="listing" query={queryNext} >&gt;</Link>
                <select className="pagination__amount btn btn-border" onChange={(e) => this.updatePerPage(e)} value={perPageValue}>
                  {defaultAmountResults.map((x, i) => <option key={i}>{x}</option>)}
                </select>
            </div>
        );
    }
});

module.exports = MediaHeaderPagination;



// WEBPACK FOOTER //
// ./app/components/headerBar/headerPagination.jsx